import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const vaillantTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.vaillant,
  logoUrl: "https://cdn.nemuru.com/assets/logos/vaillant-logo.png",
  palette: {
    primary: {
      main: "#00917e",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#00917e",
      contrastText: "#ffffff",
    },
    dark: {
      main: "#f5f5f5",
      contrastText: "#353430",
      accent: "#00917e",
      imageBackgroundOpacity: 0.85,
    },
    text: {
      title: "#333333",
      primary: "#333333",
      secondary: "#999999",
      active: "#00917e",
    },
    status: {
      active: "#08c79d",
      approved: "#00ae88",
      analysing: "#224ba0",
      sent: "#000b3d",
      cancelled: "#6e6d6b",
      denied: "#f1595c",
    },
    info: {
      main: "#00917e",
      contrastText: "#ffffff",
      light: "#ceddff",
    },
    warning: {
      main: "#f8cd51",
      contrastText: "#353430",
      light: "#fff6e7",
    },
    success: {
      main: "#00ae88",
      contrastText: "#ffffff",
      light: "rgba(0, 174, 136,0.3)",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  background: "#f4f4f4",
  assetPackDefsId: assetPackIds.OUTLINED,
  customBorderRadius: {
    button: 24,
    paper: 0,
  },
  typography: {
    fontFamily: "Arial, sans-serif",
  },
};
